@if (productConfig()?.productServerName === 'finance-mutual') {
<app-fm-dashboard-overview></app-fm-dashboard-overview>
} @else {
<div class="p-6 bg-slate-50 dark:bg-slate-900 min-h-screen font-['Lato',sans-serif]">
  <!-- Decisions on the table -->
  <section class="mb-8">
    <header class="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-4">
      <h2 class="text-[10.5px] font-[700] text-purple-700 uppercase tracking-[1.4px] m-0"><span
          class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white capitalize normal-case">Decisions
          on the Table</span></h2>
      <div class="flex items-center gap-3 flex-wrap justify-end">
        <app-date-picker [size]="'md'" (valueChange)="rangeValues($event)" (dateRangeChange)="onDateRangeChange($event)"
          [showComparison]="true" [showGroupBy]="true" [allowedGroupByUnits]="allowedGroupByUnits">
        </app-date-picker>
        @if (productConfig()?.productServerName === 'credee') {
        <div class="w-[250px]">
          <app-dropdown [options]="currencyOptions" [ngModel]="selectedCurrency()"
            (ngModelChange)="onCurrencyChange($any($event))" [placeholder]="'Currency'" [selectionMode]="'single'"
            [selectionStyle]="'none'" [type]="'selection'" [maxHeight]="'240px'" [size]="'md'">
          </app-dropdown>
        </div>
        }
      </div>
    </header>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch relative">
      @if(isLoading()){ <app-individual-toaster></app-individual-toaster> }
      <!-- Vertical Risk -->
      <div
        class="bg-white dark:bg-slate-800 pt-[18px] pr-[18px] pb-[16px] pl-[22px] rounded-xl border border-red-200 shadow-sm relative overflow-hidden flex flex-col h-full">
        <div class="absolute top-0 left-0 w-1 h-full bg-red-500"></div>
        <div class="flex items-center gap-2 mb-[11px]">
          <div class="w-2 h-2 rounded-full bg-red-500"></div>
          <span class="text-[10.5px] font-[700] tracking-[0.7px] text-red-500 uppercase">Concentration Risk</span>
        </div>
        @if(verticalRisk.name != null && verticalRisk.name !== '') {
        <p class="text-[14.5px] font-[500] leading-[1.5] text-slate-800 dark:text-slate-200 mb-[5px] h-[44px]">
          <strong class="font-[700] text-black dark:text-white">{{ verticalRisk.name }}</strong> runs <strong
            class="text-black dark:text-white">{{ verticalRisk.overdue }}% overdue</strong> across <strong
            class="text-black dark:text-white">{{ verticalRisk.contracts }} contracts</strong> — largest delinquency
          exposure.
        </p>
        <div class="border-t border-dashed border-slate-200 dark:border-slate-700 my-3"></div>
        <div class="text-[9.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase mb-[5px]">Action</div>
        <p class="text-[12.5px] leading-[1.5] text-slate-600 dark:text-slate-400 mb-0">Tighten credit terms &
          deposits on {{
          verticalRisk.name }} before new issuance.</p>
        } @else{
        <p class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data available</p>
        }
      </div>

      <!-- Growth Lever -->
      <div
        class="bg-white dark:bg-slate-800 pt-[18px] pr-[18px] pb-[16px] pl-[22px] rounded-xl border border-amber-200 shadow-sm relative overflow-hidden flex flex-col h-full">
        <div class="absolute top-0 left-0 w-1 h-full bg-amber-500"></div>
        <div class="flex items-center gap-2 mb-[11px]">
          <div class="w-2 h-2 rounded-full bg-amber-500"></div>
          <span class="text-[10.5px] font-[700] tracking-[0.7px] text-amber-500 uppercase">Growth Lever</span>
        </div>
        @if(growthLever.inactive != null && growthLever.inactive !== '') {
        <p class="text-[14.5px] font-[500] leading-[1.5] text-slate-800 dark:text-slate-200 mb-[5px] h-[44px]">
          <strong class="font-[700] text-black dark:text-white">{{ growthLever.inactive | number }}</strong> of <strong
            class="text-black dark:text-white">{{ growthLever.enrolled | number }}</strong> enrolled businesses passed
          KYC but never wrote a first contract.
        </p>
        <div class="border-t border-dashed border-slate-200 dark:border-slate-700 my-3"></div>
        <div class="text-[9.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase mb-[5px]">Action</div>
        <p class="text-[12.5px] leading-[1.5] text-slate-600 dark:text-slate-400 mb-0">Run a 7-days first-contract
          sprint —
          <strong>46%</strong> of conversions already happen inside that window.
          <!-- {{ growthLever.activationRate | number }} -->
        </p>
        } @else{
        <p class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data available</p>
        }
      </div>
      <!-- Profit Protection -->
      <div
        class="bg-white dark:bg-slate-800 pt-[18px] pr-[18px] pb-[16px] pl-[22px] rounded-xl border border-emerald-200 shadow-sm relative overflow-hidden flex flex-col h-full">
        <div class="absolute top-0 left-0 w-1 h-full bg-emerald-500"></div>
        <div class="flex items-center gap-2 mb-[11px]">
          <div class="w-2 h-2 rounded-full bg-emerald-500"></div>
          <span class="text-[10.5px] font-[700] tracking-[0.7px] text-emerald-500 uppercase">Profit Protection</span>
        </div>
        @if(profitProtection.leakage != null && profitProtection.leakage !== '') {
        <p class="text-[14.5px] font-[500] leading-[1.5] text-slate-800 dark:text-slate-200 mb-[5px] h-[44px]">
          <strong class="font-[700] text-black dark:text-white">${{ profitProtection.leakage | number:'1.2-2'
            }}</strong> of
          collected revenue leaks back out via refunds & reversals.
        </p>
        <div class="border-t border-dashed border-slate-200 dark:border-slate-700 my-3"></div>
        <div class="text-[9.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase mb-[5px]">Action</div>
        <p class="text-[12.5px] leading-[1.5] text-slate-600 dark:text-slate-400 mb-0">Attack onboarding friction —
          12% of cancellations
          are same-day, a fixable signal.</p>
        } @else {
        <p class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data available</p>
        }
      </div>
    </div>
  </section>

  <!-- Where the book stands -->
  <section class="mb-8">
    <h2 class="text-[10.5px] font-[700] text-purple-700 uppercase tracking-[1.4px] mb-4"><span
        class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white capitalize normal-case">Where
        the Book Stands</span></h2>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 relative">
      @if(isLoading()){ <app-individual-toaster></app-individual-toaster> }
      <!-- Total Financed -->
      <div
        class="bg-white dark:bg-slate-800 p-4 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden">
        <div class="flex justify-between items-start mb-2">
          <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Total Financed</h3>
          <span class="text-[9.5px]  font-bold  px-2 py-1 rounded-full"
            [ngClass]="kpis.totalFinanced.mom > 0 ? 'bg-slate-100 text-slate-600' : kpis.totalFinanced.mom < 0 ? 'bg-purple-100 text-purple-700' : 'bg-emerald-100 text-emerald-500'">{{
            kpis.totalFinanced.mom > 0 ?
            'LEADING' : kpis.totalFinanced.mom == 0 ? 'STABLE' : 'LAGGING' }}</span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-0">
          ${{ kpis.totalFinanced.value |
          number:'1.0-0' }}</div>
        <div class="text-[11.5px] leading-[1.45] text-slate-500 mt-[7px] mb-0">{{ kpis.totalFinanced.meta }}</div>
        <!-- @if (hasComparison) { -->
        <div class="text-[11px] font-[500] flex items-center gap-1 mt-[10px]"
          [ngClass]="kpis.totalFinanced.mom > 0 ? 'text-emerald-600' : kpis.totalFinanced.mom < 0 ? 'text-red-600' : 'text-orange-500'">
          <div class="w-1.5 h-1.5 rounded-full"
            [ngClass]="kpis.totalFinanced.mom > 0 ? 'bg-emerald-500' : kpis.totalFinanced.mom < 0 ? 'bg-red-500' : 'bg-orange-400'">
          </div>
          {{ comparisonLabel }} {{ kpis.totalFinanced.mom >= 0 ? '+' : '' }}{{ kpis.totalFinanced.mom | number:'1.1-1'
          }}%
        </div>
        <!-- } -->
      </div>

      <!-- Revenue Collected -->
      <div
        class="bg-white dark:bg-slate-800 p-4 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden">
        <div class="flex justify-between items-start mb-2">
          <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Revenue Collected</h3>
          <span class="text-[9.5px]  font-bold  bg-amber-100 text-amber-700 px-2 py-1 rounded-full">MIXED</span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-0">
          ${{ kpis.revenueCollected.value |
          number:'1.0-0' }}</div>
        <div class="text-[11.5px] leading-[1.45] text-slate-500 mt-[7px] mb-0">{{ kpis.revenueCollected.meta }}</div>
        <!-- @if (hasComparison) { -->
        <div class="text-[11px] font-[500] flex items-center gap-1 mt-[10px]"
          [ngClass]="kpis.revenueCollected.mom > 0 ? 'text-emerald-600' : kpis.revenueCollected.mom < 0 ? 'text-red-600' : 'text-orange-500'">
          <div class="w-1.5 h-1.5 rounded-full"
            [ngClass]="kpis.revenueCollected.mom > 0 ? 'bg-emerald-500' : kpis.revenueCollected.mom < 0 ? 'bg-red-500' : 'bg-orange-400'">
          </div>
          {{ comparisonLabel }} {{ kpis.revenueCollected.mom >= 0 ? '+' : '' }}{{ kpis.revenueCollected.mom |
          number:'1.1-1' }}%
        </div>
        <!-- } -->
      </div>

      <!-- Active Businesses -->
      <div
        class="bg-white dark:bg-slate-800 p-4 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden">
        <div class="flex justify-between items-start mb-2">
          <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Active Businesses</h3>
          <span class="text-[9.5px]  font-bold  px-2 py-1 rounded-full"
            [ngClass]="kpis.activeBusinesses.mom > 0 ? 'bg-slate-100 text-slate-600' : kpis.activeBusinesses.mom < 0 ? 'bg-purple-100 text-purple-700' : 'bg-emerald-100 text-emerald-500'">{{
            kpis.activeBusinesses.mom > 0 ?
            'LEADING' : kpis.activeBusinesses.mom == 0 ? 'STABLE' : 'LAGGING' }} </span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-0">
          {{ kpis.activeBusinesses.value | number }}
        </div>
        <div class="text-[11.5px] leading-[1.45] text-slate-500 mt-[7px] mb-0">{{ kpis.activeBusinesses.meta }}</div>
        <!-- @if (hasComparison) { -->
        <div class="text-[11px] font-[500] flex items-center gap-1 mt-[10px]"
          [ngClass]="kpis.activeBusinesses.mom > 0 ? 'text-emerald-600' : kpis.activeBusinesses.mom < 0 ? 'text-red-600' : 'text-orange-500'">
          <div class="w-1.5 h-1.5 rounded-full"
            [ngClass]="kpis.activeBusinesses.mom > 0 ? 'bg-emerald-500' : kpis.activeBusinesses.mom < 0 ? 'bg-red-500' : 'bg-orange-400'">
          </div>
          {{ comparisonLabel }} {{ kpis.activeBusinesses.mom >= 0 ? '+' : '' }}{{ kpis.activeBusinesses.mom |
          number:'1.1-1' }}%
        </div>
        <!-- } -->
      </div>

      <!-- Total Contracts -->
      <div
        class="bg-white dark:bg-slate-800 p-4 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden">
        <div class="flex justify-between items-start mb-2">
          <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Total Contracts</h3>
          <span class="text-[9.5px]  font-bold   px-2 py-1 rounded-full"
            [ngClass]="kpis.totalContracts.mom > 0 ? 'bg-slate-100 text-slate-600' : kpis.totalContracts.mom < 0 ? 'bg-purple-100 text-purple-700' : 'bg-emerald-100 text-emerald-500'">{{
            kpis.totalContracts.mom > 0 ?
            'LEADING' : kpis.totalContracts.mom == 0 ? 'STABLE' : 'LAGGING' }}</span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-0">
          {{ kpis.totalContracts.value | number }}
        </div>
        <div class="text-[11.5px] leading-[1.45] text-slate-500 mt-[7px] mb-0">{{ kpis.totalContracts.meta }}</div>
        <!-- @if (hasComparison) { -->
        <div class="text-[11px] font-[500] flex items-center gap-1 mt-[10px]"
          [ngClass]="kpis.totalContracts.mom > 0 ? 'text-emerald-600' : kpis.totalContracts.mom < 0 ? 'text-red-600' : 'text-orange-500'">
          <div class="w-1.5 h-1.5 rounded-full"
            [ngClass]="kpis.totalContracts.mom > 0 ? 'bg-emerald-500' : kpis.totalContracts.mom < 0 ? 'bg-red-500' : 'bg-orange-400'">
          </div>
          {{ comparisonLabel }} {{ kpis.totalContracts.mom >= 0 ? '+' : '' }}{{ kpis.totalContracts.mom | number:'1.1-1'
          }}%
        </div>
        <!-- } -->
      </div>

      <!-- Activation Rate -->
      <div
        class="bg-gradient-to-br from-purple-50 from-0% to-white to-70% dark:from-slate-800 dark:to-slate-900 pt-[17px] px-[18px] pb-[16px] rounded-xl shadow-[0_8px_26px_rgba(124,58,237,0.13)] border-[1.5px] border-purple-200 dark:border-purple-900 border-l-[4px] border-l-purple-600 relative overflow-hidden">
        <div class="flex justify-between items-start mb-[11px]">
          <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Activation Rate</h3>
          <span
            class="text-[9.5px] font-[700] tracking-[0.4px] px-2 py-1 rounded-full bg-purple-100 text-purple-700">KEY
            LEVER</span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-0">
          {{ kpis.activationRate.value |
          number:'1.1-1' }}%</div>
        <div class="text-[11.5px] leading-[1.45] text-slate-500 mt-[7px] mb-0">{{ kpis.activationRate.meta }}</div>
        <div class="mt-[13px]">
          <div class="h-[7px] rounded-[6px] bg-[#dde9eb] dark:bg-slate-700 overflow-hidden relative">
            <div class="h-full rounded-[6px] bg-gradient-to-r from-purple-600 to-blue-500 relative"
              [style.width.%]="kpis.activationRate.value"></div>
          </div>
          <!-- <div class="flex justify-between text-[10.5px] font-[600] text-slate-500 mt-[6px]">
            <span>Now {{ kpis.activationRate.value | number:'1.1-1' }}%</span>
            <span>Target <span class="text-purple-700 dark:text-purple-400 font-bold">45%</span> &middot; +125 contracts/yr</span>
          </div> -->
        </div>
      </div>

      <!-- Top Industry Share -->
      <div
        class="bg-white dark:bg-slate-800 p-4 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden">
        <div class="flex justify-between items-start mb-2">
          <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Top Industry Share</h3>
          <span class="text-[9.5px] font-bold  px-2 py-1 rounded-full uppercase"
            [ngClass]="kpis.topIndustryShare.value < 30 ? 'bg-slate-100 text-slate-600' : kpis.topIndustryShare.value < 45 ? 'bg-orange-100 text-orange-700' : 'bg-red-100 text-red-700'">{{
            kpis.topIndustryShare.value < 30 ? 'BALANCED' : kpis.topIndustryShare.value < 45 ? 'MODERATE'
              : 'CONCENTRATED' }} </span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-0">
          {{ kpis.topIndustryShare.value |
          number:'1.0-0' }}%</div>
        <div class="text-[11.5px] leading-[1.45] text-slate-500 mt-[7px] mb-0">{{ kpis.topIndustryShare.meta }}</div>
        <!-- @if (hasComparison) { -->
        <div class="text-[11px] font-[500] flex items-center gap-1 mt-[10px]"
          [ngClass]="kpis.topIndustryShare.mom > 0 ? 'text-emerald-600' : kpis.topIndustryShare.mom < 0 ? 'text-red-600' : 'text-orange-500'">
          <div class="w-1.5 h-1.5 rounded-full"
            [ngClass]="kpis.topIndustryShare.mom > 0 ? 'bg-emerald-500' : kpis.topIndustryShare.mom < 0 ? 'bg-red-500' : 'bg-orange-400'">
          </div>
          {{ comparisonLabel }} {{ kpis.topIndustryShare.mom >= 0 ? '+' : '' }}{{ kpis.topIndustryShare.mom |
          number:'1.1-1' }}%
        </div>
        <!-- } -->
      </div>
    </div>

    <!-- Churn Rate Card Section -->
    <div
      class="bg-gradient-to-r from-red-50 to-white dark:from-red-900/20 dark:to-slate-800 border border-red-100 dark:border-red-900/30 border-l-[4px] border-l-red-600 rounded-xl p-4 mt-3 flex flex-col lg:flex-row gap-4 relative">
      @if (isCriticalBusinessLoading()) { <app-individual-toaster fontSize="16px" /> }

      <!-- Left Side -->
      <div class="flex-1 flex flex-col justify-between">
        <div>
          <div class="flex items-center gap-2 mb-2 text-slate-500 dark:text-slate-400">
            <h3 class="text-[11px] font-[600] text-slate-500">CHURN RATE</h3>
            <span
              class="bg-[#fdf1da] dark:bg-orange-950/40 text-[#b45309] dark:text-orange-300 text-[9px] font-[700] uppercase px-2 py-0.5 rounded-full tracking-wider ml-auto">WATCH</span>
          </div>

          <div class="text-[28px] font-bold text-slate-900 dark:text-white leading-tight">
            {{ criticalBusinessData()?.portfolio_churn_rate || '0.0' }}%
          </div>

          <p class="text-[11.5px] text-slate-500 dark:text-slate-400 mt-2 leading-snug">
            <span class="font-semibold text-slate-700 dark:text-slate-300">{{ (criticalBusinessData()?.critical_risk ||
              0) | number }}</span> cancelled of {{ totalContractsCount() | number }} all-time contracts (FY) ·
            <span class="font-semibold text-slate-700 dark:text-slate-300">{{
              (criticalBusinessData()?.businesses_near_churn || 0) | number }}</span> businesses currently at {{
            totalActiveContracts() | number }} active contracts.
          </p>
        </div>

        <div class="flex flex-col items-start gap-2 mt-4 text-[12px]">
          <!-- @if (hasComparison) { -->
          <div class="flex items-center gap-1.5 text-slate-500 dark:text-slate-400 font-semibold">
            <span class="w-1.5 h-1.5 rounded-full bg-[#d97706] dark:[#d97706]"></span>
            {{ comparisonLabel }} {{ criticalBusinessData()?.churnGrowthText || '0.0%' }}
          </div>
          <!-- } -->
          <a (click)="openRiskModal()"
            class="text-red-600 dark:text-[#dc2626] font-bold hover:underline cursor-pointer flex items-center gap-1">
            ▶ View at-risk businesses
          </a>
        </div>
      </div>

      <!-- Right Side -->
      <div class="flex-1 lg:pl-6 lg:border-l lg:border-red-200/60 lg:dark:border-red-900/40 flex flex-col">
        <div class="mb-6">
          <h4 class="text-[16px] font-bold text-slate-900 dark:text-white">
            {{ atRiskBusinessesCount() | number }} Businesses · {{ totalActiveContracts() | number }} Active Contracts
          </h4>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 w-full">
          <div
            class="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl p-3 shadow-sm">
            <div class="text-[9px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-1">AT-RISK
              BUSINESSES</div>
            <div class="text-[20px] font-bold text-slate-900 dark:text-white">
              {{ atRiskBusinessesCount() | number }}
            </div>
          </div>

          <div
            class="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl p-3 shadow-sm">
            <div class="text-[9px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-1">AVG DAYS
              SINCE CONTACT</div>
            <div class="text-[20px] font-bold text-slate-900 dark:text-white">
              {{ avgDaysSinceContact() | number }}
            </div>
          </div>

          <div
            class="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl p-3 shadow-sm">
            <div class="text-[9px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-1">
              HISTORICAL CONTRACTS</div>
            <div class="text-[20px] font-bold text-slate-900 dark:text-white">
              {{ totalContractsCount() | number }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Top markets -->
  @if (productConfig()?.productServerName === 'credee') {
  <section class="mb-8">
    <div class="mb-6">
      <!-- <p class="text-[10.5px] font-[700] text-purple-700 uppercase tracking-[1.4px] flex items-center gap-2 mb-1">
        <span class="inline-block w-[18px] h-0.5 bg-purple-600 rounded-sm"></span>
        Global footprint
      </p> -->
      <h2 class="text-2xl font-medium text-[#141437] dark:text-white">Top
        markets</h2>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-[1.6fr_1fr] gap-6 relative">
      @if(isLoading()){ <app-individual-toaster></app-individual-toaster> }
      <div
        class="bg-white dark:bg-slate-800 pt-[17px] px-[18px] pb-[16px] rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden">
        <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Top
          markets — share of contracts</h3>
        <p class="text-xs text-slate-500 dark:text-slate-400 mt-1 mb-4">{{ topMarkets.chartSubtitle }}</p>
        <div class="w-full">
          @if (topMarkets.chartData?.length) {
          <app-horizontal-bar-chart [data]="topMarkets.chartData" [showXAxisGrid]="false" [showXAxisLabel]="false"
            [showYAxisLine]="true" [showYAxisLabel]="true" [colorYAxisLabels]="false" [barHeight]="56"
            [showBarsValue]="true" [minHeight]="getTopMarketsChartMinHeight()" [marginTop]="20" [marginBottom]="48"
            [leftMargin]="getTopMarketsLeftMargin()" [forceMaxVal]="getTopMarketsMaxVal()" [showTooltipTotal]="true"
            [valueType]="'%'" class="w-full block">
          </app-horizontal-bar-chart>
          } @else {
          <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500 min-h-[250px]">
            <app-icon-v2 name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon-v2>
            <p class="text-lg font-medium">No data available</p>
            <p class="text-sm mt-1">Data will appear here when available</p>
          </div>
          }
        </div>
        <!-- @if (topMarkets.chartFootnote) {
        <p class="text-xs text-slate-500 dark:text-slate-400 mt-4 pt-3">
          {{ topMarkets.chartFootnote }}
        </p>
        } -->
      </div>

      <div
        class="bg-white dark:bg-slate-800 pt-[17px] px-[18px] pb-[16px] rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden">
        <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">
          Emerging markets</h3>

        <p class="text-xs text-slate-500 dark:text-slate-400 mt-1 mb-2">
          {{ topMarkets.emerging.marketCount }} tail markets · {{ topMarkets.emerging.share }}% of contracts · the
          diversification thesis
        </p>
        @if (topMarkets.emerging.marketCount > 0){
        <div class="mt-2.5">
          @for (row of topMarkets.emerging.rows; track $index; let last = $last) {
          <div class="flex justify-between items-center gap-4 py-[11px]" [class.border-b]="!last"
            [class.border-dashed]="!last" [class.border-slate-200]="!last" [class.dark:border-slate-600]="!last">
            <div class="min-w-0">
              <div class="text-[13.5px] font-[600] text-slate-900 dark:text-white leading-snug">{{ row.name }}</div>
              @if (row.subtitle) {
              <div class="text-[10.5px] text-slate-500 dark:text-slate-400 mt-0.5">{{ row.subtitle }}</div>
              }
            </div>
            <div class="text-right shrink-0">
              <div class="text-base font-semibold tabular-nums" [style.color]="row.pctColor">{{ row.share }}%</div>
              <div class="text-xs text-slate-500 dark:text-slate-400 tabular-nums">{{ row.total | number }}</div>
            </div>
          </div>
          } @empty {
          <p class="text-sm text-slate-500 dark:text-slate-400 py-4">No tail markets for the selected period.</p>
          }
        </div>
        } @else {
        <p class="text-lg mt-4 font-medium">No data available</p>
        }
      </div>
    </div>
  </section>
  }

  <!-- What's driving the numbers -->
  <section class="mb-8">
    <h2 class="text-[10.5px] font-[700] text-purple-700 uppercase tracking-[1.4px] mb-4"><span
        class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white capitalize normal-case">What's
        Driving the Numbers</span></h2>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 relative">
      @if(isLoading()){ <app-individual-toaster></app-individual-toaster> }
      <div
        class="bg-gradient-to-r from-emerald-50 to-white dark:from-emerald-900/20 dark:to-slate-800 py-[18px] px-[20px] rounded-xl shadow-sm border border-emerald-300 dark:border-emerald-500/50 flex flex-col justify-between relative overflow-hidden">
        <div>
          <h3
            class="text-[11px] font-[700] tracking-[0.5px] text-emerald-600 dark:text-emerald-500 uppercase mb-[5px] flex items-center gap-1">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4L22 20H2L12 4Z" />
            </svg>
            BEST PERFORMING INDUSTRY
          </h3>
          @if(drivingNumbers.bestIndustry?.speciality_name != null && drivingNumbers.bestIndustry?.speciality_name !==
          '')
          {
          <div
            class="font-['Lato',sans-serif] font-['Lato',sans-serif] text-[19px] font-[700] tracking-[-0.3px] text-slate-900 dark:text-white mb-[5px]">
            {{
            drivingNumbers.bestIndustry?.speciality_name }}</div>
          <div class="text-[11.5px] text-slate-500">
            Avg financed ${{ $safeNavigationMigration(drivingNumbers.bestIndustry?.average_financed_amount) | number:'1.0-0' }} · {{
            drivingNumbers.bestIndustry?.overdue_ratio }}% overdue · {{ drivingNumbers.bestIndustry?.total_contracts }}
            contracts
          </div>
          } @else{
          <p class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data available</p>
          }
        </div>

      </div>
      <div
        class="bg-gradient-to-r from-red-50 to-white dark:from-red-900/20 dark:to-slate-800 py-[18px] px-[20px] rounded-xl shadow-sm border border-red-300 dark:border-red-500/50 flex flex-col justify-between relative overflow-hidden">
        <div>
          <h3
            class="text-[11px] font-[700] tracking-[0.5px] text-red-600 dark:text-red-500 uppercase mb-[5px] flex items-center gap-1">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 20L2 4H22L12 20Z" />
            </svg>
            HIGHEST RISK INDUSTRY
          </h3>
          @if(drivingNumbers.worstIndustry?.speciality_name != null &&
          drivingNumbers.worstIndustry?.speciality_name !== '') {
          <div
            class="font-['Lato',sans-serif] font-['Lato',sans-serif] text-[19px] font-[700] tracking-[-0.3px] text-slate-900 dark:text-white mb-[5px]">
            {{
            drivingNumbers.worstIndustry?.speciality_name }}</div>
          <div class="text-[11.5px] text-slate-500">
            {{ drivingNumbers.worstIndustry?.overdue_ratio }}% overdue · {{
            drivingNumbers.worstIndustry?.total_contracts
            }} contracts · {{ getDelinquentCount(drivingNumbers.worstIndustry) }} delinquent
          </div>
          } @else{
          <p class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data available</p>
          }
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 relative">
      @if(isLoading()){ <app-individual-toaster></app-individual-toaster> }
      <div
        class="bg-white dark:bg-slate-800 pt-[17px] px-[18px] pb-[16px] rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden flex flex-col">
        <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">
          Contract Type Mix</h3>
        <p class="text-[13px] text-slate-500 mt-[4px] mb-[13px]">What businesses use &middot; {{ formattedDateRange }}
        </p>
        <div class="w-full">
          @if (contractTypeMixChart?.length) {
          <app-horizontal-bar-chart [data]="contractTypeMixChart" [showXAxisGrid]="true" [showXAxisLabel]="true"
            [showYAxisLine]="false" [colorYAxisLabels]="false" [barHeight]="40" [barPadding]="0.3"
            [roundedCorners]="true" [minHeight]="getContractTypeMixChartMinHeight()" [marginTop]="20"
            [marginBottom]="40" [leftMargin]="getContractTypeMixLeftMargin()" [maxLabelWidth]="130"
            [forceMaxVal]="getContractTypeMixMaxVal()" [yAxisTickPadding]="10" [cornerRadius]="4" valueType="%"
            class="w-full block">
          </app-horizontal-bar-chart>
          } @else {
          <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500 min-h-[200px]">
            <app-icon-v2 name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon-v2>
            <p class="text-lg font-medium">No data available</p>
            <p class="text-sm mt-1">Data will appear here when available</p>
          </div>
          }
        </div>
      </div>
      <div
        class="bg-white dark:bg-slate-800 pt-[17px] px-[18px] pb-[16px] rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden flex flex-col">
        <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">
          Active Businesses — Industry Split</h3>
        <p class="text-[13px] text-slate-500 mt-[4px] mb-[13px]">12-months stacked &middot; {{ formattedDateRange }}</p>
        <div class="flex-grow relative min-h-[300px]">
          @if (activeBizChart?.hasData) {
          <app-multi-stacked-bar-chart [data]="activeBizChart.data" [legendData]="activeBizChart.legend"
            [yAxisTicks]="9" [showOnlyFirstLastXAxis]="activeBizChart.showOnlyFirstLastXAxis"
            class="absolute inset-0 w-full h-full">
          </app-multi-stacked-bar-chart>
          <!-- [scrollable]="shouldEnableScroll()" for scroll -->
          } @else {
          <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500 absolute inset-0 w-full">
            <app-icon-v2 name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon-v2>
            <p class="text-lg font-medium">No data available</p>
            <p class="text-sm mt-1">Data will appear here when available</p>
          </div>
          }
        </div>
      </div>
    </div>
  </section>

  <!-- Net Revenue Waterfall -->
  <section class="mb-8">
    <div
      class="bg-white dark:bg-slate-800 pt-[17px] px-[18px] pb-[16px] rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden flex flex-col">
      @if(isLoading()){ <app-individual-toaster></app-individual-toaster> }
      <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Net
        Revenue Waterfall — Full Year</h3>
      <p class="text-[13px] text-slate-500 mt-[4px] mb-[13px]">{{ formattedDateRange }} &middot; Net ${{
        $safeNavigationMigration(waterfallChart?.net) | number:'1.2-2' }}M after leakage</p>
      <div class="w-full">
        @if (waterfallChart?.hasData) {
        <app-horizontal-bar-chart [data]="waterfallChart.data" [showXAxisGrid]="true" [showXAxisLabel]="true"
          [showYAxisLine]="false" [colorYAxisLabels]="false" [barHeight]="30" [barPadding]="0.3" [roundedCorners]="true"
          [minHeight]="getWaterfallChartMinHeight()" [marginTop]="20" [marginBottom]="40"
          [leftMargin]="getWaterfallLeftMargin()" [forceMaxVal]="getWaterfallMaxVal()"
          [forceMinVal]="getWaterfallMinVal()" [xTickValues]="getWaterfallTickValues()" [yAxisTickPadding]="10"
          [cornerRadius]="4" valueType="currency" class="w-full block">
        </app-horizontal-bar-chart>
        } @else {
        <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500 min-h-[250px]">
          <app-icon-v2 name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon-v2>
          <p class="text-lg font-medium">No data available</p>
          <p class="text-sm mt-1">Data will appear here when available</p>
        </div>
        }
      </div>
    </div>
  </section>

  <!-- At-Risk Businesses Modal -->
  @if (isRiskModalOpen()) {
  <div class="fixed inset-0 bg-slate-950/60 backdrop-blur-sm z-[6000] flex items-center justify-center p-4">
    <div
      class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-5xl max-h-[90vh] flex flex-col overflow-hidden border border-slate-200 dark:border-slate-700 animate-in fade-in zoom-in-95 duration-200">

      <!-- Modal Header -->
      <div class="p-5 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
        <div>
          <span class="text-[10px] font-bold uppercase tracking-wider text-red-600 dark:text-red-400">Churn Risk
            Analysis</span>
          <h3 class="text-lg font-bold text-slate-900 dark:text-white mt-0.5">At-Risk Businesses</h3>
        </div>
        <button (click)="closeRiskModal()"
          class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-400 hover:text-slate-600 dark:hover:text-white transition-colors">
          ✕
        </button>
      </div>

      <!-- Modal Body -->
      <div class="p-6 overflow-y-auto flex-grow space-y-5">
        <!-- Summary Metrics Cards -->
        <div class="grid grid-cols-2 md:grid-cols-5 gap-3">
          <div class="bg-slate-50 dark:bg-slate-900/40 border border-slate-200 dark:border-slate-700/60 rounded-xl p-3">
            <div class="text-[9px] font-bold text-slate-500 uppercase tracking-wider">Total Businesses</div>
            <div class="text-xl font-bold text-slate-900 dark:text-white mt-1">{{
              $safeNavigationMigration(criticalBusinessData()?.total_businesses) | number }}</div>
          </div>
          <div class="bg-red-50/50 dark:bg-red-950/20 border border-red-100 dark:border-red-900/30 rounded-xl p-3">
            <div class="text-[9px] font-bold text-red-600 dark:text-red-400 uppercase tracking-wider">Critical Risk
            </div>
            <div class="text-xl font-bold text-red-700 dark:text-red-300 mt-1">{{ $safeNavigationMigration(criticalBusinessData()?.critical_risk)
              | number }}</div>
          </div>
          <div
            class="bg-orange-50/50 dark:bg-orange-950/20 border border-orange-100 dark:border-orange-900/30 rounded-xl p-3">
            <div class="text-[9px] font-bold text-orange-600 dark:text-orange-400 uppercase tracking-wider">High Risk
            </div>
            <div class="text-xl font-bold text-orange-700 dark:text-orange-300 mt-1">{{
              $safeNavigationMigration(criticalBusinessData()?.high_risk) | number }}</div>
          </div>
          <div
            class="bg-amber-50/50 dark:bg-amber-950/20 border border-amber-100 dark:border-amber-900/30 rounded-xl p-3">
            <div class="text-[9px] font-bold text-amber-600 dark:text-amber-400 uppercase tracking-wider">Medium Risk
            </div>
            <div class="text-xl font-bold text-amber-700 dark:text-amber-300 mt-1">{{
              $safeNavigationMigration(criticalBusinessData()?.medium_risk) | number }}</div>
          </div>
          <div
            class="bg-emerald-50/50 dark:bg-emerald-950/20 border border-emerald-100 dark:border-emerald-900/30 rounded-xl p-3">
            <div class="text-[9px] font-bold text-emerald-600 dark:text-emerald-400 uppercase tracking-wider">Healthy
            </div>
            <div class="text-xl font-bold text-emerald-700 dark:text-emerald-300 mt-1">{{
              $safeNavigationMigration(criticalBusinessData()?.healthy) | number }}</div>
          </div>
        </div>

        <!-- Controls Section -->
        <div class="flex flex-col sm:flex-row gap-4 justify-between sm:items-center">
          <!-- Search -->
          <input type="text" [ngModel]="riskSearchQuery()" (ngModelChange)="setRiskSearchQuery($event)"
            placeholder="Search by business name or owner..."
            class="bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 w-full sm:w-80 text-slate-950 dark:text-white" />

          <!-- Filter Tabs -->
          <div class="flex flex-wrap gap-1.5">
            @for (tier of ['All', 'Critical', 'High', 'Medium', 'Healthy']; track tier) {
            <button (click)="setRiskTier(tier)" [ngClass]="{
                    'bg-violet-600 border-violet-600 text-white shadow-sm': selectedRiskTier() === tier,
                    'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50': selectedRiskTier() !== tier
                  }" class="px-3 py-1.5 rounded-lg text-xs font-semibold border transition-all">
              {{ tier }}
            </button>
            }
          </div>
        </div>

        <!-- Table -->
        <div class="overflow-x-auto border border-slate-200 dark:border-slate-700 rounded-xl">
          <table class="w-full text-left border-collapse">
            <thead>
              <tr class="border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/40">
                <th class="py-3 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">Practice</th>
                <th class="py-3 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">Owner</th>
                <th class="py-3 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">Risk</th>
                <th class="py-3 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider text-right">Days
                  Since Contact</th>
                <th class="py-3 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider text-right">Total
                  Contracts</th>
                <th class="py-3 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider text-right">Cancelled
                </th>
                <th class="py-3 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-wider">Last Contract</th>
              </tr>
            </thead>
            <tbody>
              @for (item of paginatedRiskDetails(); track item.doctor_id; let i = $index) {
              <tr [ngClass]="{
                      'bg-slate-50/50 dark:bg-slate-800/40': i % 2 === 0,
                      'bg-white dark:bg-slate-800': i % 2 !== 0
                    }"
                class="border-b border-slate-200/60 dark:border-slate-700/60 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors">
                <td class="py-3.5 px-4 text-xs font-bold text-slate-900 dark:text-white">{{ item.practice_name }}</td>
                <td class="py-3.5 px-4 text-xs text-slate-700 dark:text-slate-300">{{ item.business_owner }}</td>
                <td class="py-3.5 px-4 text-xs">
                  <span [ngClass]="{
                          'bg-red-50 dark:bg-red-950/40 text-red-600 dark:text-red-400 border border-red-100 dark:border-red-900/30': item.churn_risk === 'Critical',
                          'bg-orange-50 dark:bg-orange-950/40 text-orange-600 dark:text-orange-400 border border-orange-100 dark:border-orange-900/30': item.churn_risk === 'High',
                          'bg-amber-50 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 border border-amber-100 dark:border-amber-900/30': item.churn_risk === 'Medium',
                          'bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-900/30': item.churn_risk === 'Healthy'
                        }" class="px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider">
                    {{ item.churn_risk }}
                  </span>
                </td>
                <td class="py-3.5 px-4 text-xs text-slate-700 dark:text-slate-300 text-right font-medium">{{
                  item.days_since_last_contract }}</td>
                <td class="py-3.5 px-4 text-xs text-slate-700 dark:text-slate-300 text-right font-medium">{{
                  item.total_contracts }}</td>
                <td class="py-3.5 px-4 text-xs text-slate-700 dark:text-slate-300 text-right font-medium">{{
                  item.total_contracts - item.active_contracts }}</td>
                <td class="py-3.5 px-4 text-xs text-slate-500 dark:text-slate-400">{{ item.last_contract_date |
                  date:'mediumDate' }}</td>
              </tr>
              }
              @if (filteredRiskDetails().length === 0) {
              <tr>
                <td colspan="7" class="py-8 text-center text-sm text-slate-400 dark:text-slate-500">
                  No matching at-risk businesses found
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Pagination Component -->
        @if (filteredRiskDetails().length > 0) {
        <app-pagination [currentPage]="riskCurrentPage()" [totalItems]="filteredRiskDetails().length"
          [pageSize]="riskPageSize()" [pageSizes]="[5, 10, 15, 20]" (pageChange)="onRiskPageChange($event)"
          (pageSizeChange)="onRiskPageSizeChange($event)"></app-pagination>
        }
      </div>

      <!-- Modal Footer -->
      <div
        class="p-4 border-t border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/20 flex justify-end">
        <button (click)="closeRiskModal()"
          class="px-4 py-2 bg-slate-200 dark:bg-slate-700 text-slate-800 dark:text-white font-semibold text-xs rounded-lg hover:bg-slate-300 dark:hover:bg-slate-600 transition-colors">
          Close Panel
        </button>
      </div>
    </div>
  </div>
  }
</div>
}